import { PierResponseDto } from '@planning/app/api'
import { pierService } from '@planning/services'
import { makeObservable } from 'mobx'
import { EntityItem } from '../base/EntityItem'
import { ItemStore } from '../base/ItemStore'
import { IEntityStore } from '../types'
import { IPierItem } from './PierItem'

export class PierItemStore
  extends ItemStore<PierResponseDto, IPierItem, string>
  implements IEntityStore<IPierItem>
{
  private hasBeenLoaded = false

  constructor() {
    super((key, data) => new EntityItem<PierResponseDto, string>(key, data))
    makeObservable(this, {})

    // messageBus.subscribeEvent(GetBerthsQuery.type, this.receiveBerthsMessage)
    // messageBus.subscribeEvent(EventTypes.BerthUpsertedEvent, this.receiveBerthUpsertedEventMessage)
  }

  fetch = async () => {
    if (this.hasBeenLoaded) return

    this.hasBeenLoaded = true

    const result = await pierService.get()

    this.upsertBulk(result)
  }

  // receiveBerthsMessage = (event: IEvent<BerthResponseDto[]>): void => {
  //   if (event.payload) {
  //     this.upsertBulk(event.payload)
  //   }
  // }

  // receiveBerthUpsertedEventMessage = (event: IEvent<BerthResponseDto>) => {
  //   if (event.payload) {
  //     this.upsert(event.payload)
  //   }
  // }
}
